var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "webContent flex",
      attrs: { scroll: "" },
      on: { scroll: _vm.listenScroll }
    },
    [
      _c("div", { staticClass: "mine" }, [
        _c("div", { staticClass: "area" }, [
          _c("div", { staticClass: "user df hao" }, [
            _c("div", { staticClass: "uname" }, [_vm._v(_vm._s(_vm.user))]),
            _vm._v(" "),
            _c("div", { staticClass: "point flex" }, [
              _vm._v("积分：" + _vm._s(_vm.point))
            ]),
            _vm._v(" "),
            _vm.isFollow
              ? _c(
                  "div",
                  {
                    staticClass: "state state2",
                    on: { click: _vm.showCancelFollow }
                  },
                  [_vm._v("已关注")]
                )
              : _c(
                  "div",
                  { staticClass: "state", on: { click: _vm.followUser } },
                  [_vm._v("关注")]
                )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "duty" }, [_vm._v(_vm._s(_vm.duty))]),
          _vm._v(" "),
          _c("div", { staticClass: "social df hao" }, [
            _c("div", { staticClass: "socialLi" }, [
              _c("em", [_vm._v(_vm._s(_vm.followCount))]),
              _vm._v("关注Ta的人")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "socialLi" }, [
              _c("em", [_vm._v(_vm._s(_vm.followCount2))]),
              _vm._v("Ta关注的人")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "social2 df hao" }, [
            _c("div", { staticClass: "socialLi2" }, [
              _vm._v("得到"),
              _c("em", [_vm._v(_vm._s(_vm.likeCount))]),
              _vm._v("点赞")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "socialLi3" }, [
              _vm._v("已被"),
              _c("em", [_vm._v(_vm._s(_vm.collectCount))]),
              _vm._v("次收藏")
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "list" },
          _vm._l(_vm.list, function(v, i) {
            return _c(
              "div",
              {
                staticClass: "li",
                on: {
                  click: function($event) {
                    return _vm.toDetail(v)
                  }
                }
              },
              [
                _c("div", { staticClass: "cap df hao" }, [
                  _c("em", [_vm._v(_vm._s(_vm.user))]),
                  _vm._v(
                    _vm._s(v.day) +
                      " · " +
                      _vm._s(v.type == "question" ? "发布了提问" : "回答了问题")
                  )
                ]),
                _vm._v(" "),
                _vm._l(v.item, function(v2, i2) {
                  return v.type == "question"
                    ? _c("div", { staticClass: "item" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(_vm._s(v2.title))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "tool" }, [
                          _vm._v(
                            _vm._s(v2.lastDate) +
                              " · " +
                              _vm._s(
                                v2.answerCount > 0
                                  ? v2.answerCount + "人回答"
                                  : "暂无回答"
                              ) +
                              " · " +
                              _vm._s(
                                v2.followCount > 0
                                  ? v2.followCount + "人关注"
                                  : "暂无关注"
                              )
                          )
                        ])
                      ])
                    : _vm._l(v.item, function(v2, i2) {
                        return _c("div", { staticClass: "item2" }, [
                          _c("div", { staticClass: "title2" }, [
                            _c("i", { staticClass: "top" }),
                            _vm._v(_vm._s(v2.title))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "txt ov-4d",
                              domProps: { innerHTML: _vm._s(v2.txt) }
                            },
                            [_vm._v(_vm._s(v2.txt))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "end df hao" }, [
                            _c(
                              "div",
                              {
                                staticClass: "like",
                                class: { has: v2.question.approval != 0 },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.likeItem(
                                      v2.question.id,
                                      v2.question.approval,
                                      v2.question
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(v2.question.approvalTotal))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "collect",
                                class: { has: v2.question.collection != 0 },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.collectItem(
                                      v2.question.id,
                                      v2.question.collection,
                                      v2.question
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(v2.question.collectionTotal))]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "user2" }, [
                              _vm._v(_vm._s(v2.user))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "date" }, [
                              _vm._v(_vm._s(v2.date))
                            ])
                          ])
                        ])
                      })
                })
              ],
              2
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _vm.cancelFollow.has
        ? _c("div", { staticClass: "cancelFollow df wao hao" }, [
            _c("div", { staticClass: "cancelFollow-box" }, [
              _c("div", { staticClass: "cancelFollow-txt" }, [
                _vm._v("确认不再关注"),
                _c("em", [_vm._v(_vm._s(_vm.cancelFollow.user))]),
                _vm._v("吗？")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cancelFollow-end df war hao" }, [
                _c(
                  "div",
                  {
                    staticClass: "cancelFollow-btn",
                    on: { click: _vm.closeCancelFollow }
                  },
                  [_vm._v("放弃")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "cancelFollow-btn",
                    on: { click: _vm.resCancelFollow }
                  },
                  [_vm._v("取消关注")]
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.collectBase.has
        ? _c("div", { staticClass: "collectBase" }, [
            _c("div", { staticClass: "collectBase-box" }, [
              _c("div", { staticClass: "collectBase-top" }, [
                _c("div", {
                  staticClass: "collectBase-close",
                  on: { click: _vm.closeCollectBase }
                }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "已选择" +
                      _vm._s(_vm.collectBase.choose.length) +
                      "个收藏夹"
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "collectBase-add",
                    on: { click: _vm.showCollectAddBase }
                  },
                  [_vm._v("新建收藏夹")]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "collectBase-list" },
                _vm._l(_vm.collectBase.list, function(v, i) {
                  return _c(
                    "div",
                    {
                      staticClass: "collectBase-li df cf wao",
                      class: { cur: _vm.collectBase.choose.indexOf(i) >= 0 },
                      on: {
                        click: function($event) {
                          return _vm.chooseCollectBase(i)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "collectBase-title" }, [
                        _vm._v(_vm._s(v.name))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "collectBase-answer" }, [
                        _vm._v(_vm._s(v.answerTotal) + "个回答")
                      ])
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "collectBase-btn",
                  on: { click: _vm.resCollectBase }
                },
                [_vm._v("确认")]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.collectAddBase.has
        ? _c("div", { staticClass: "collectAddBase df wao hao" }, [
            _c("div", { staticClass: "collectAddBase-box" }, [
              _c("div", { staticClass: "collectAddBase-input df hao" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.collectAddBase.val,
                      expression: "collectAddBase.val"
                    }
                  ],
                  staticClass: "flex",
                  attrs: {
                    type: "text",
                    puc: "",
                    placeholder: "输入收藏夹标题"
                  },
                  domProps: { value: _vm.collectAddBase.val },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.collectAddBase, "val", $event.target.value)
                      },
                      _vm.checkInput
                    ]
                  }
                }),
                _vm._v(" "),
                _c("i", [_vm._v(_vm._s(13 - _vm.collectAddBase.val.length))])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "collectAddBase-end df war hao" }, [
                _c(
                  "div",
                  {
                    staticClass: "collectAddBase-btn",
                    on: { click: _vm.resCollectAddBase }
                  },
                  [_vm._v("确认")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "collectAddBase-btn",
                    on: { click: _vm.closeCollectAddBase }
                  },
                  [_vm._v("取消")]
                )
              ])
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78524cec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78524cec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/me/user/user.vue
// module id = null
// module chunks = 